import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import type { StructuralUnitMinimalListItem } from 'types/structural-unit.interface';

export interface AddCoResponsibleResult {
  structuralUnitId: string | null;
  isConsolidated: boolean;
}

@Component({
  selector: 'app-ir-add-co-responsible-modal',
  standalone: true,
  imports: [FormsModule, TranslateModule, TooltipComponent],
  templateUrl: './ir-add-co-responsible-modal.component.html'
})
export class IrAddCoResponsibleModalComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() isConsolidated = false;
  @Input() availableUnits: StructuralUnitMinimalListItem[] = [];
  @Input() coResponsibleCount = 0;
  @Input() isLoading = false;
  @Output() confirmed = new EventEmitter<AddCoResponsibleResult>();
  @Output() closed = new EventEmitter<void>();
  @ViewChild('content') content!: TemplateRef<unknown>;

  selectedUnitId = '';
  consolidatedChecked = false;

  constructor(private modalService: NgbModal) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['isOpen']) return;
    if (this.isOpen) {
      this.consolidatedChecked = this.isConsolidated;
      this.selectedUnitId = '';
      this.modalService.open(this.content, { backdrop: 'static', keyboard: false, windowClass: 'send-email-modal' });
    } else {
      this.modalService.dismissAll();
    }
  }

  get isConsolidatedDisabled(): boolean {
    return !this.consolidatedChecked && this.coResponsibleCount === 0 && !this.selectedUnitId;
  }

  get canSave(): boolean {
    if (this.selectedUnitId) return true;
    return this.consolidatedChecked !== this.isConsolidated;
  }

  confirm(): void {
    if (!this.canSave || this.isLoading) return;
    this.confirmed.emit({
      structuralUnitId: this.selectedUnitId || null,
      isConsolidated: this.consolidatedChecked
    });
  }

  close(): void {
    this.modalService.dismissAll();
    this.closed.emit();
  }
}
